module.exports = __webpack_public_path__ + "img/20191129165826360截图20191129161306435.22bff9bb.jpg";